import { render, staticRenderFns } from "./errorMsg.vue?vue&type=template&id=7975eeb3&"
import script from "./errorMsg.vue?vue&type=script&lang=js&"
export * from "./errorMsg.vue?vue&type=script&lang=js&"
import style0 from "./errorMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports